import { NavigateBackLink } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Box, PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamLocationManagementLayout() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-location/requests/create');

  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.CREATE]}
    >
      <PageHeader
        title='สร้างคำขออนุมัติสถานที่สอบ'
        linkAdornment={
          <NavigateBackLink
            to='/:examCenterCode/exam-location/requests'
            params={{ examCenterCode }}
            label='Back'
          />
        }
      />
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <Outlet />
      </Box>
    </PermissionGuard>
  );
}
